import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LogService } from '../services/log.service';
import { environment } from '../../environments/environment';

/**
 * DÉTAILS: Un AuthGuard est une fonction qui détermine si une route peut être activée.
 * C'est le portier de notre application.
 *
 * @returns Un booléen qui indique si la navigation est autorisée.
 */
export const authGuard: CanActivateFn = (): boolean => {
  // 🔓 Mode bypass pour tester sans connexion
  if (environment.bypassAuth) {
    const log = inject(LogService);
    log.warn('Auth Guard BYPASSED - dev mode');
    return true;
  }

  const authService = inject(AuthService);
  const router = inject(Router);

  // Utilise le signal directement (synchrone)
  if (authService.isLoggedIn()) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
